<template>
  <div class="year-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Year Selection Section -->
    <section class="year-selection">
      <div class="container">
        <div class="year-content">
          <PageTitle title="Select Your Vehicle Year" />
          
          <div class="years-grid">
            <button 
              v-for="year in years" 
              :key="year"
              :class="['year-button', { 'selected': selectedYear === year }]"
              @click="selectYear(year)"
            >
              {{ year }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'
import carInfoData from '@/data/car_info.json'

export default {
  name: 'YearPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedYear: null,
      userQuoteData: null,
      years: [],
      carInfo: carInfoData
    }
  },
  mounted() {
    this.loadUserData()
    this.loadYearsFromCarInfo()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          
          // 检查是否是添加车辆模式，设置当前选择
          if (this.userQuoteData.adding_vehicle && this.userQuoteData.temp_vehicle) {
            this.selectedYear = this.userQuoteData.temp_vehicle.car_year
          } else {
            this.selectedYear = this.userQuoteData.car_year
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.initializeUserData()
        }
      } else {
        this.initializeUserData()
      }
    },
    
    initializeUserData() {
      // 从路由参数或localStorage获取zipcode
      const zipCode = this.$route.query.zip || ''
      this.userQuoteData = {
        zip_code: zipCode,
        host_name: "policyautoquotes.com",
        car_use: "",
        annual_distance: "",
        coverage_type: "",
        own_rent: "",
        has_insurance: "",
        months_insured: "",
        accidents: "0",
        violations: "0",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        birthday: "",
        gender: 2,
        marital_status: "",
        address: "",
        city: "",
        state: "",
        military: "",
        car_year: "",
        car_make: "",
        car_model: "",
        car_distance: "",
        car_own: "",
        vehicles: []
      }
      this.saveUserData()
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    loadYearsFromCarInfo() {
      // 从car_info.json文件中获取所有可用年份
      const availableYears = Object.keys(this.carInfo)
      
      // 转换为数字并排序（从新到旧）
      this.years = availableYears
        .map(year => parseInt(year))
        .sort((a, b) => b - a)
      
      console.log('Available years from car_info.json:', this.years)
    },
    
    async selectYear(year) {
      this.selectedYear = year
      
      // 检查是否是添加车辆模式
      if (this.userQuoteData.adding_vehicle && this.userQuoteData.temp_vehicle) {
        // 添加车辆模式：更新临时车辆数据
        this.userQuoteData.temp_vehicle.car_year = year.toString()
        console.log('Selected year for additional vehicle:', year)
      } else {
        // 第一辆车模式：更新主车辆数据
        this.userQuoteData.car_year = year.toString()
        console.log('Selected year for primary vehicle:', year)
      }
      
      this.saveUserData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('year')
      
      // 跳转到品牌选择页面
      this.$router.push('/make')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.year-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* Year Selection */
.year-selection {
  padding: 4rem 0;
  background: #fff;
  flex: 1;
}

.year-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}



.years-grid {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.year-button {
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.year-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
}

.year-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
}



/* Responsive Design */
@media (max-width: 768px) {

  .years-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.8rem;
  }

  .year-button {
    padding: 0.8rem 0.5rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .year-selection {
    padding: 2rem 0;
  }



  .years-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.6rem;
    padding: 0 1rem;
  }

  .year-button {
    padding: 0.7rem 0.3rem;
    font-size: 0.85rem;
  }
}
</style>
